module.exports = __webpack_public_path__ + "static/media/mashkanta.e92c531c.svg";